import React from "react";

import IngresoLoading from "./ingreso/loading.component";
import IngresoLoadingMobile from "./ingresoMobile/loading.component";

import Canvas from "./canvas.component";
import CanvasMobile from "./canvasMobile.component";

import mobileAndTabletCheck from "../utils/mobileCheck";
/* import {
  MouseParallaxContainer,
  MouseParallaxChild,
} from "react-parallax-mouse"; */

import axios from "axios";

/*eslint-disable*/

interface Ingreso {
  preloadImages: Array<String>;
}

interface Props {}

interface State {
  data: any;
  dataIntro: any;
  progress: number;
  currentImage: number;
  isIngresoHidden: boolean;
  loadedImages: number;
  isMobile: boolean;
  colorOnHover: string
  introFrame: string;
  moveIngreso: boolean,
  showRender: boolean
}

declare const window: any;

class Ingreso extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      data: {},
      dataIntro: {},
      progress: 0,
      currentImage: 0,
      isIngresoHidden: false,
      loadedImages: 0,
      isMobile: false,
      colorOnHover: '',
      introFrame: '',
      moveIngreso:true,
      showRender: false
    };
  }

  

  async componentDidMount() {
    console.log(window.hybrid);
    window.addEventListener("resize", () => {
      var currentSize = this.state.isMobile
      this.setState({
        isMobile:
          mobileAndTabletCheck() && window.innerHeight > window.innerWidth,
      }, () => {
        if(currentSize !== this.state.isMobile){
          location.reload()
        }
      });
    });
    setTimeout(() => {
      this.setState({
        moveIngreso: false
      }, () => {
        setTimeout(() => {
          this.setState({
            showRender: true
          })
        }, 1500)
      })
    }, 300) 


    this.setState({
      isMobile:
        mobileAndTabletCheck() && window.innerHeight > window.innerWidth,
    });

    let dataIntro: any = window.hybrid ? window.intro : await axios.post(
      //"http://localhost:4000/api/client/intro",
      "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client/intro",
      { project: window.project_id || "CP50" }
    )

    

    let dataJsonIntro: any = dataIntro.data

    this.setState({
      dataIntro: dataJsonIntro.project
    })

    let data: any = window.hybrid ? window.client : await axios.post(
      //"http://localhost:4000/api/client",
      "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client",
      { project: window.project_id || "CP50" }
    );
    //.then((res) => res.json())
    
    let dataJson: any = data.data;

    const head = document.querySelector("head");

    if (dataJson.project.favicon) {
      const link = document.createElement("link");

      link.setAttribute("rel", "icon");
      link.setAttribute(
        "href",
        (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
          dataJson.project.faviconPNG
      );
      link.setAttribute("size", "any");
      link.setAttribute("type", "image/png");

      head?.appendChild(link);

      const linkS: any = document.createElement("link");
      linkS.rel = "shortcut icon";
      linkS.href =
        (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
        dataJson.project.favicon;
      head?.appendChild(linkS);
    }

    if (dataJson.project.faviconPNG) {
      const linkiOS = document.createElement("link");
      linkiOS.setAttribute("rel", '"apple-touch-icon');
      linkiOS.setAttribute(
        "href",
        (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
          dataJson.project.faviconPNG
      );
      linkiOS.setAttribute("size", "any");
      linkiOS.setAttribute("type", "image/png");

      head?.appendChild(linkiOS);
    }

    document.title =
      dataJson.project.nombre_constructora +
      " | " +
      dataJson.project.nombre_proyecto;

      console.log(dataJson.project);
      

    this.setState(
      {
        data: dataJson.project,
      },
      () => {

        console.log(this.state.data)

        this.preloadImages = [];

        const scrollbar: any = document.documentElement;

        // Add CSS styles to the scrollbar
        scrollbar.style.scrollbarWidth = "thin";
        scrollbar.style.scrollbarColor = "blue gray";

        // Modify the pseudo-element for the scrollbar
        document.documentElement.style.setProperty("--scrollbarBG", "#ffffff");
        document.documentElement.style.setProperty(
          "--thumbBG",
          this.state.data.colors.main_buttons
        );

        if(this.handleIsLigthColor(this.state.data.colors.main_buttons)){
          const darkColor = this.handleCreateShade(this.state.data.colors.main_buttons, true)
          this.setState({
            colorOnHover: darkColor
          }, () => {
            document.documentElement.style.setProperty("--colorOnHover", this.state.colorOnHover)
          })
        }
        else{
          const ligthColor = this.handleCreateShade(this.state.data.colors.main_buttons, false)
          this.setState({
            colorOnHover: ligthColor
          }, () => {
            document.documentElement.style.setProperty("--colorOnHover", this.state.colorOnHover)
          })
        }

        

        // Add the CSS rules for the scrollbar pseudo-element
        const style = document.createElement("style");
        style.innerHTML = `
          ::-webkit-scrollbar {
            width: 0.2rem;
            height: 0rem
          }
          ::-webkit-scrollbar-horizontal {
            height: 2px;
          }
          ::-webkit-scrollbar-track {
            background-color: var(--scrollbarBG);
          }
          ::-webkit-scrollbar-thumb {
            background-color: var(--thumbBG);
            border-radius: 6px;
          }
        `;
        document.head.appendChild(style);

        if(this.state.isMobile){
          this.state.data.spin.map((spin: any, index: number) => {
              if (spin.type === "General portrait") {
                spin.files.forEach((file: any, index: any) => {
                  if(index % 2 === 0){
                    this.preloadImages.push(file);
                  }
                });
              }
            });
        }
        else{
          this.state.data.spin.map((spin: any, index: number) => {
            if (spin.type === "General landscape") {
              spin.files.forEach((file: any, index: any) => {
                if(index === 0){
                  this.setState({
                    introFrame: file
                  })
                }
                if(index % 2 === 0){
                  this.preloadImages.push(file);
                }
              });
            }
          });
        }


        let counter = 0;

        this.preloadImages.forEach((imageSrc, index) => {
          console.log(imageSrc);
          
          new Promise((resolve, reject) => {
            const image = new Image();
            image.src =
              (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + imageSrc;

            image.onload = (event) => {
              counter++;
              this.setState({
                progress: Math.floor(
                  (counter * 100) / this.preloadImages.length
                ),
              });
            };
          });
        });
      }
    );
  }

  handleHideIngreso = () => {
    this.setState({
      moveIngreso: true
    }, () => {
      setTimeout(() => {
        this.setState({
          isIngresoHidden: !this.state.isIngresoHidden,
        });
      },800)
    })
    
  };

  handleIsLigthColor = (payload: any) => {
    var hexColor: any = payload.replace("#", "");

    // Convert the hex color to RGB
    const red = parseInt(hexColor.substring(0, 2), 16);
    const green = parseInt(hexColor.substring(2, 4), 16);
    const blue = parseInt(hexColor.substring(4, 6), 16);

    // Calculate the relative luminance
    const relativeLuminance = (red * 0.2126 + green * 0.7152 + blue * 0.0722) / 255;

    // Return true if the relative luminance is above a threshold (0.5 in this case)
    return relativeLuminance > 0.4;
  }

  handleCreateShade = (hexColor: any , isLight: any) =>  {
  // Remove the "#" character if present
  hexColor = hexColor.replace("#", "");

  // Convert the hex color to RGB
  const red = parseInt(hexColor.substring(0, 2), 16);
  const green = parseInt(hexColor.substring(2, 4), 16);
  const blue = parseInt(hexColor.substring(4, 6), 16);

  // Calculate the factor for darkening or lightening the color
  const factor = isLight ? 0.8 : 1.8;

  // Darken or lighten the color by applying the factor to each channel
  const newRed = Math.max(Math.min(Math.floor(red * factor), 255), 0);
  const newGreen = Math.max(Math.min(Math.floor(green * factor), 255), 0);
  const newBlue = Math.max(Math.min(Math.floor(blue * factor), 255), 0);

  // Convert the new RGB values back to hex
  const newHexColor =
    "#" +
    ("00" + newRed.toString(16)).slice(-2) +
    ("00" + newGreen.toString(16)).slice(-2) +
    ("00" + newBlue.toString(16)).slice(-2);

  return newHexColor;
}

  render() {
    return (
      <React.Fragment>
        {!this.state.isMobile ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
            }}
          >
            {this.state.data && this.state.data.colors ? (
              <Canvas
                isIngresoHidden={this.state.isIngresoHidden}
                data={this.state.data}
                colorOnHover={this.state.colorOnHover}
              />
            ) : null}
            <div
              className={
                this.state.isIngresoHidden
                  ? "ingreso-page fade-out"
                  : "ingreso-page fade-in"
              }
            >
              {this.state.dataIntro &&
              this.state.dataIntro.hasOwnProperty("background") ? (
                <React.Fragment>
                  {this.state.introFrame !== '' && this.state.showRender ?
                    <div className="main-frame-container">
                      <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + this.state.introFrame}/>
                    </div>:null
                  }
                  {/* <MouseParallaxContainer
                    globalFactorX={0.1}
                    globalFactorY={0.1}
                  >
                    <div className={this.state.moveIngreso ? 'parallax-container-collpased':'parallax-container'}>
                      <MouseParallaxChild factorX={1} factorY={1}>
                        <img
                          src={
                            (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                            this.state.dataIntro.background
                          }
                          alt=""
                        />
                      </MouseParallaxChild>
                    </div>
                    <IngresoLoading
                      data={this.state.dataIntro}
                      progress={this.state.progress}
                      handleHideIngreso={this.handleHideIngreso}
                      isIngresoHidden={this.state.isIngresoHidden}
                      moveIngreso = {this.state.moveIngreso}
                    />
                  </MouseParallaxContainer> */}
                    <div className={this.state.moveIngreso ? 'parallax-container-collpased':'parallax-container'}>
                        <img
                          src={
                            (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                            this.state.dataIntro.background
                          }
                          alt=""
                        />
                    </div>
                    <IngresoLoading
                      data={this.state.dataIntro}
                      progress={this.state.progress}
                      handleHideIngreso={this.handleHideIngreso}
                      isIngresoHidden={this.state.isIngresoHidden}
                      moveIngreso = {this.state.moveIngreso}
                    />
                </React.Fragment>
              ) : null}
            </div>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
            }}
          >
            {this.state.data && this.state.data.colors ? (
              <CanvasMobile
                isIngresoHidden={this.state.isIngresoHidden}
                data={this.state.data}
              />
            ) : null}
            <div
              className={
                this.state.isIngresoHidden
                  ? "ingreso-page-mobile fade-out"
                  : "ingreso-page-mobile fade-in"
              }
            >
              {this.state.dataIntro ? (
                <React.Fragment>
                  <img
                    src={
                      (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                      this.state.dataIntro.background
                    }
                    alt=""
                  />
                  <IngresoLoadingMobile
                    data={this.state.dataIntro}
                    progress={this.state.progress}
                    handleHideIngreso={this.handleHideIngreso}
                    isIngresoHidden={this.state.isIngresoHidden}
                  />
                </React.Fragment>
              ) : null}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Ingreso;
